(() => {
  const ROOT = '[id^="HobbytechPartsFinder-"]';
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function init(root) {
    if (!root || root.dataset.hpfPopupInitialized === 'true') return;
    const popup = root.querySelector('[data-hpf-finder-popup]');
    if (!popup) return;

    root.dataset.hpfPopupInitialized = 'true';
    const dialog = popup.querySelector('[data-hpf-finder-popup-dialog]');
    const closeButton = popup.querySelector('.hpf-finder-popup__close');
    let returnFocus = null;
    let pageScrollY = 0;
    let hideTimer = null;

    const productDialogOpen = () => Boolean(root.querySelector('.hpf-dialog[open]'));
    const isOpen = () => popup.classList.contains('is-open') && !popup.hidden;

    function lockPage() {
      pageScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('hpf-popup-open');
      document.body.classList.add('hpf-popup-open');
      document.body.style.top = `-${pageScrollY}px`;
    }

    function unlockPage() {
      document.documentElement.classList.remove('hpf-popup-open');
      document.body.classList.remove('hpf-popup-open');
      document.body.style.top = '';
      window.scrollTo(0, pageScrollY);
    }

    function openPopup(trigger) {
      if (isOpen()) return;
      if (hideTimer) window.clearTimeout(hideTimer);
      returnFocus = trigger || document.activeElement;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      lockPage();

      requestAnimationFrame(() => {
        popup.classList.add('is-open');
        requestAnimationFrame(() => {
          closeButton?.focus({ preventScroll: true });
          window.dispatchEvent(new Event('resize'));
        });
      });
    }

    function closePopup({ restoreFocus = true } = {}) {
      if (!isOpen()) return;
      root.querySelectorAll('.hpf-dialog[open]').forEach(item => item.close?.());
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      unlockPage();

      hideTimer = window.setTimeout(() => {
        popup.hidden = true;
      }, 210);

      if (restoreFocus && returnFocus?.focus) {
        requestAnimationFrame(() => returnFocus.focus({ preventScroll: true }));
      }
    }

    root.querySelectorAll('[data-hpf-open-finder]').forEach(button => {
      button.addEventListener('click', () => openPopup(button));
    });

    popup.querySelectorAll('[data-hpf-close-finder]').forEach(control => {
      control.addEventListener('click', event => {
        event.preventDefault();
        closePopup();
      });
    });

    popup.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        if (productDialogOpen()) return;
        event.preventDefault();
        closePopup();
        return;
      }

      if (event.key !== 'Tab' || !dialog) return;
      const focusable = [...dialog.querySelectorAll(FOCUSABLE)].filter(item => {
        const style = window.getComputedStyle(item);
        return !item.hidden && style.display !== 'none' && style.visibility !== 'hidden';
      });
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root) && isOpen()) closePopup({ restoreFocus: false });
    });
  }

  function scan(scope = document) {
    if (scope.matches?.(ROOT)) init(scope);
    scope.querySelectorAll?.(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
